import { useFormik } from "formik";
import {useEffect, useMemo, useState} from "react";
import * as Yup from "yup";
import useUserData from "../user/useUserData";
import {useTranslation} from "react-i18next";
import {PAGE_LOGIN} from "../../locales/pages/namespaces";
import axios from "axios";
import {API} from "../../helpers/constants";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors} from "../../helpers/errorHandling";
import * as yup from "yup";
import {useAddresses} from "./useAddresses";
import {useHistory} from "react-router-dom";
import {getRouteUrl} from "../../helpers/routing/getRouteUrl";
import {ROUTE_ADDRESSES, ROUTE_PRODUCT_LIST} from "../../routers/routes";
import useCartData from "../cart/useCartData";


export function useAddressData({ id, initialCountries = [] } = {}) {
  const isEdit = Boolean(id);
  const [loading, setLoading] = useState(false);
  const [addressData, setAddressData] = useState([]);
  const { token } = useUserData();
  const history = useHistory();
  const { t } = useTranslation(PAGE_LOGIN);
 const [countries, setCountries] = useState(initialCountries);

  useEffect(() => {
    if (!token) return;
      if (!id && initialCountries.length > 0) {
          setCountries(initialCountries);
          return;
      }
    setLoading(true);

    axios({
      method: "post",
      url: `${API}/en/brew/address/edit`,
      data:{
        id:id
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
        .then((res) => {
          setAddressData(res.data?.data.address ?? null);
          setCountries(res.data?.data.countries ?? null);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          enqueueSnackbar(handleAxiosErrors(error, t("An error occurred!")), {
            variant: "error",
            autoHideDuration: 3000,
          });
        });
  }, [token, t]);

  const onSubmit = (values) => {
    setLoading(true);
    axios({
      method: "post",
      url: `${API}/en/brew/address/store`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
         id:id ? id : '',
        Address: values.Address,
        CountryId: values.CountryId,
        City: values.City,
        Region: values.Region,
        ZipCode: values.ZipCode,
        AddrPhone: values.AddrPhone,
        Comments: values.Comments,
          isInvoice: String(values.isInvoice) === "1" ? "1" : "0",
      },
    })
        .then(() => {
          enqueueSnackbar(t("Address was successfully submitted!"), {
            variant: "success",
            autoHideDuration: 3000,
          });
          setLoading(false);
            history.push(getRouteUrl(ROUTE_ADDRESSES))
        })
        .catch((error) => {
          setLoading(false);
          enqueueSnackbar(handleAxiosErrors(error, t("An error occurred!")), {
            variant: "error",
            autoHideDuration: 3000,
          });
        });
  };

  const validationSchema = yup.object().shape({
    Address: Yup.string().required("Υποχρεωτικό πεδίο"),
    CountryId: Yup.string().required("Υποχρεωτικό πεδίο"),
    City: Yup.string().required("Υποχρεωτικό πεδίο"),
    Region: Yup.string().required("Υποχρεωτικό πεδίο"),
    AddrPhone: Yup.string()
        .required("Υποχρεωτικό πεδίο")
        .min(6, "Πολύ μικρός αριθμός"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues:{
      Address:addressData ? addressData.Address : "",
        CountryId: addressData?.CountryId ? String(addressData.CountryId) : "",
      City: addressData ?addressData.City : "",
      Region: addressData ?addressData.Region : "",
      ZipCode: addressData ?addressData.ZipCode : "",
      AddrPhone: addressData ?addressData.AddrPhone : "",
      Comments: addressData ?addressData.Comments : "",
      isInvoice: addressData ?addressData.isInvoice : false,
    },
    validationSchema,
    onSubmit,
  });


  return {
    formik,
    loading,
    isEdit,
    countries,
  };
}
